(function () {
  function numberRange(start, end, step, suffix) {
    var values = [];
    for (var value = start; value <= end + 0.001; value += step) {
      var precision = step === 0.25 ? 2 : step === 0.5 ? 1 : 0;
      var label = value.toFixed(precision).replace(/\.00$/, '').replace(/\.0$/, '') + suffix;
      values.push(label);
    }
    return values;
  }

  var sizes = {
    necklace: ['14 inches', '16 inches', '18 inches', '20 inches', '22 inches', '24 inches', '26 inches', '28 inches', '30 inches'],
    chain: ['14 inches', '16 inches', '18 inches', '20 inches', '22 inches', '24 inches', '26 inches', '28 inches', '30 inches'],
    bracelet: numberRange(5, 9, 0.25, ' inches'),
    anklet: numberRange(5, 9, 0.25, ' inches'),
    ring: numberRange(3, 14, 0.5, ' US'),
    pendant: ['Under 0.5 inch', '0.5–0.99 inch', '1–1.49 inches', '1.5–1.99 inches', '2–2.49 inches', '2.5–2.99 inches', '3 inches or larger'],
    earrings: ['Under 5 mm', '5–7 mm', '8–10 mm', '11–15 mm', '16–25 mm', 'Over 25 mm'],
    charm: ['Under 0.5 inch', '0.5–0.99 inch', '1–1.49 inches', '1.5–1.99 inches', '2 inches or larger'],
    brooch: ['Under 1 inch', '1–1.49 inches', '1.5–1.99 inches', '2–2.99 inches', '3 inches or larger'],
    cufflinks: ['Small / subtle', 'Standard', 'Large / statement'],
    other: ['Custom measurements', 'Not sure — advise me']
  };

  function initForm(form) {
    var pieceType = form.querySelector('[data-piece-type]');
    var sizeField = form.querySelector('[data-size-field]');
    var sizeSelect = form.querySelector('[data-size-select]');
    var metalType = form.querySelector('[data-metal-type]');
    var compositionField = form.querySelector('[data-metal-composition-field]');
    var compositionLabel = form.querySelector('[data-metal-composition-label]');
    var compositionSelect = form.querySelector('[data-metal-composition]');
    var colorField = form.querySelector('[data-metal-color-field]');
    var colorOptions = Array.prototype.slice.call(form.querySelectorAll('[data-color-option]'));
    var colorInputs = Array.prototype.slice.call(form.querySelectorAll('[data-metal-color]'));
    var colorNote = form.querySelector('[data-metal-color-note]');
    var stoneChoice = form.querySelector('[data-stone-choice]');
    var stoneFields = form.querySelectorAll('[data-stone-field]');
    var upload = form.querySelector('[data-image-upload]');
    var fileList = form.querySelector('[data-file-list]');
    var steps = Array.prototype.slice.call(form.querySelectorAll('[data-wizard-step]'));
    var progressSteps = Array.prototype.slice.call(form.querySelectorAll('[data-progress-step]'));
    var stepStatus = form.querySelector('[data-step-status]');
    var backButton = form.querySelector('[data-wizard-back]');
    var nextButton = form.querySelector('[data-wizard-next]');
    var submitButton = form.querySelector('[data-wizard-submit]');
    var finalContent = Array.prototype.slice.call(form.querySelectorAll('[data-final-step-content]'));
    var currentStep = 0;

    function showStep(index, moveFocus) {
      currentStep = Math.max(0, Math.min(index, steps.length - 1));

      steps.forEach(function (step, stepIndex) {
        step.hidden = stepIndex !== currentStep;
      });

      progressSteps.forEach(function (step, stepIndex) {
        step.classList.toggle('is-active', stepIndex === currentStep);
        step.classList.toggle('is-complete', stepIndex < currentStep);
        if (stepIndex === currentStep) step.setAttribute('aria-current', 'step');
        else step.removeAttribute('aria-current');
      });

      var isLastStep = currentStep === steps.length - 1;
      backButton.hidden = currentStep === 0;
      nextButton.hidden = isLastStep;
      submitButton.hidden = !isLastStep;
      finalContent.forEach(function (element) { element.hidden = !isLastStep; });
      stepStatus.textContent = 'Step ' + (currentStep + 1) + ' of ' + steps.length;

      if (moveFocus) {
        steps[currentStep].scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.setTimeout(function () { steps[currentStep].focus({ preventScroll: true }); }, 350);
      }
    }

    function currentStepIsValid() {
      var fields = Array.prototype.slice.call(steps[currentStep].querySelectorAll('input, select, textarea'));
      var invalidField = fields.find(function (field) {
        return !field.disabled && !field.checkValidity();
      });

      if (invalidField) {
        invalidField.reportValidity();
        invalidField.focus();
        return false;
      }
      return true;
    }

    function updateSizes() {
      var options = sizes[pieceType.value] || [];
      sizeSelect.innerHTML = '';

      if (!pieceType.value) {
        sizeField.hidden = true;
        sizeSelect.disabled = true;
        return;
      }

      ['Select a size'].concat(options, ['Custom size / exact measurements in notes', 'Not sure — advise me']).forEach(function (label, index) {
        var option = document.createElement('option');
        option.value = index === 0 ? '' : label;
        option.textContent = label;
        option.disabled = index === 0;
        option.selected = index === 0;
        sizeSelect.appendChild(option);
      });

      sizeField.hidden = false;
      sizeSelect.disabled = false;
    }

    function setCompositionOptions(label, options) {
      compositionLabel.innerHTML = label + ' <em>*</em>';
      compositionSelect.innerHTML = '';

      if (options.length > 1) {
        var placeholder = document.createElement('option');
        placeholder.value = '';
        placeholder.textContent = 'Select one';
        placeholder.disabled = true;
        placeholder.selected = true;
        compositionSelect.appendChild(placeholder);
      }

      options.forEach(function (value) {
        var option = document.createElement('option');
        option.value = value;
        option.textContent = value;
        compositionSelect.appendChild(option);
      });
    }

    function updateMetalColors() {
      var metal = metalType.value;
      var is24K = metal === 'gold' && compositionSelect.value === '24K gold';
      var allowed = metal === 'gold' && !is24K
        ? ['yellow', 'white', 'rose', 'yellow-white', 'rose-white', 'three-tone']
        : metal ? [metal === 'gold' ? 'yellow' : 'white'] : [];

      colorOptions.forEach(function (option) {
        var enabled = allowed.indexOf(option.getAttribute('data-color-option')) !== -1;
        var input = option.querySelector('input');
        option.hidden = !enabled;
        input.disabled = !enabled;
        if (!enabled) input.checked = false;
      });

      if (allowed.length === 1) {
        var onlyInput = colorOptions.find(function (option) {
          return option.getAttribute('data-color-option') === allowed[0];
        }).querySelector('input');
        onlyInput.checked = true;
      }

      colorNote.textContent = is24K
        ? '24K gold is available in yellow only.'
        : metal === 'silver' || metal === 'platinum'
          ? 'This metal is available in white only.'
          : 'Two-tone and three-tone combinations are available through 22K.';
    }

    function updateMetalFields() {
      var metal = metalType.value;
      colorInputs.forEach(function (input) { input.checked = false; });
      compositionField.hidden = !metal;
      colorField.hidden = !metal;
      compositionSelect.disabled = !metal;

      if (metal === 'gold') {
        setCompositionOptions('Gold karat', ['10K gold', '14K gold', '18K gold', '22K gold', '24K gold']);
      } else if (metal === 'silver') {
        setCompositionOptions('Silver purity', ['925 sterling silver']);
      } else if (metal === 'platinum') {
        setCompositionOptions('Platinum alloy', ['950 PT with Iridium', '950 PT with Ruthenium']);
      } else {
        compositionSelect.innerHTML = '<option value="">Select a metal first</option>';
      }

      updateMetalColors();
    }

    function updateStoneFields() {
      var show = stoneChoice.value === 'yes' || stoneChoice.value === 'unsure';
      stoneFields.forEach(function (field) {
        field.hidden = !show;
        var select = field.querySelector('select');
        if (select) select.disabled = !show;
      });
    }

    pieceType.addEventListener('change', updateSizes);
    metalType.addEventListener('change', updateMetalFields);
    compositionSelect.addEventListener('change', updateMetalColors);
    stoneChoice.addEventListener('change', updateStoneFields);

    if (steps.length && backButton && nextButton && submitButton) {
      form.classList.add('is-wizard');
      steps.forEach(function (step) { step.setAttribute('tabindex', '-1'); });
      backButton.addEventListener('click', function () { showStep(currentStep - 1, true); });
      nextButton.addEventListener('click', function () {
        if (currentStepIsValid()) showStep(currentStep + 1, true);
      });
      showStep(0, false);
    }

    if (upload && fileList) {
      upload.addEventListener('change', function () {
        var files = Array.prototype.slice.call(upload.files || []);
        if (files.length > 5) {
          upload.value = '';
          fileList.textContent = 'Please choose no more than 5 images.';
          fileList.classList.add('custom-piece__file-list--error');
          return;
        }

        var oversized = files.some(function (file) { return file.size > 10 * 1024 * 1024; });
        if (oversized) {
          upload.value = '';
          fileList.textContent = 'Each image must be 10 MB or smaller.';
          fileList.classList.add('custom-piece__file-list--error');
          return;
        }

        fileList.classList.remove('custom-piece__file-list--error');
        fileList.textContent = files.length
          ? files.map(function (file) { return file.name; }).join(' • ')
          : '';
      });
    }

    updateSizes();
    updateMetalFields();
    updateStoneFields();
  }

  document.querySelectorAll('[data-custom-piece-form]').forEach(initForm);

  var success = document.querySelector('[data-form-success]');
  if (success) success.focus();
})();
